const $ = require('jquery');
const { isNumber } = require('lodash');

/**
 * This directive adds a class "is-sticky" to an element when the document scrolls past a given position.
 * It leaves the actual implemntation of the "is-sticky" class up to the caller.
 *
 * @class StickyController
 */
class StickyController {
    constructor($element, $timeout) {
        this.$element = $element;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.isSticky = false;
    }

    $postLink() {
        this.$timeout(() => {
            this.stickAtScrollPosition = this.calculateStickAt();
            this.toggleSticky();
        }, 0, false);

        this.scrollingElement = document.scrollingElement ? document.scrollingElement : document.documentElement;

        this.onScroll = () => requestAnimationFrame(() => this.toggleSticky());
        document.addEventListener('scroll', this.onScroll, { passive: true });
    }

    $onDestroy() {
        document.removeEventListener('scroll', this.onScroll, { passive: true });
    }

    calculateStickAt() {
        if (this.stickAtScrollPosition) {
            return this.stickAtScrollPosition;
        }
        if (this.stickTo == null) {
            // By default, stick when this element reaches the top.
            return this.$element.offset().top;
        }

        if (isNumber(this.stickTo)) {
            return this.stickTo;
        }

        const $el = $(this.stickTo);

        if ($el && $el.length > 0) {
            return $el.offset().top + $el.outerHeight();
        }

        throw Error('Provided position to stick to must be a number.');
    }

    toggleSticky() {
        const wasSticky = this.isSticky;
        this.isSticky = this.scrollingElement.scrollTop > this.calculateStickAt();

        if (!wasSticky && this.isSticky) {
            this.$element.addClass('is-sticky');
        } else if (wasSticky && !this.isSticky) {
            this.$element.removeClass('is-sticky');
        }
    }
}

const stickyDirectiveDefinition = () => ({
    restrict: 'A',
    scope: {
        stickTo: '=?olySticky',
    },
    controller: ['$element', '$timeout', StickyController],
    bindToController: true,
    controllerAs: '$ctrl',
});

module.exports = {
    StickyController,
    stickyDirectiveDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/sticky/sticky.directive.js